import React from "react";
import PropTypes from "prop-types";
import { FormGroup, Row, Col, ControlLabel, FormControl} from "react-bootstrap";
import DatePicker from "react-datepicker";
import Select from "react-select";
import moment from "moment";
import InlineError from "../../../messages/InlineError";

const RecurringFields = (props) => (
	<React.Fragment>
		<Row>
			{/* project manager */}
			<Col md={6}>
				<FormGroup validationState={props.errors.manager_id && "error"}>
					<ControlLabel>Project Manager</ControlLabel>
					<Select.Async
						onChange={(option) => { props.onAsyncChange(option, "manager_id", "selectedManager"); }}
						name="manager_id"
						placeholder="Search Project Manager"
						value={props.selectedManager}
						labelKey="full_name"
						valueKey="id"
						loadOptions={(e,c)=>props.handleAsyncSearch(e,"user","roles=1,2",c)}
						clearable={false}
						multi={false}
					/>
					{props.errors.manager_id && <InlineError text={props.errors.manager_id} />}
				</FormGroup>
			</Col>
			<Col md={6}>
				<ControlLabel>Parent</ControlLabel>
				<FormGroup validationState={props.errors.parent_id && "error"}>
					<Select.Async
						onChange={(option) => { props.onParentSelectChange(option, "parent_id"); }}
						name="parent_id"
						placeholder="Choose parent project"
						value={props.selectedProject}
						labelKey="name"
						valueKey="id"
						loadOptions={(e,c)=>props.handleAsyncSearch(e,"project",null,c)}
						clearable={false}
						multi={false}
						disabled={props.disabled}
					/>
					{props.errors.parent_id && <InlineError text={props.errors.parent_id} />}
				</FormGroup>	    				
			</Col>
		</Row>
		<Row>
			{/* project customer */}
			<Col md={6}>
				<FormGroup validationState={props.errors.client_id && "error"}>
					<ControlLabel>Customer</ControlLabel>
					<Select.Async
						onChange={(option) => { props.onCustomerAsyncChange(option, "client_id", "selectedCustomer"); }}
						name="client_id"
						placeholder="Search Customer"
						labelKey="full_name"
						valueKey="id"
						value={props.selectedCustomer}
						loadOptions={(e,c)=>props.handleAsyncSearch(e,"user","roles=3",c)}
						clearable={false}
						multi={false}
						disabled={props.disabled || props.disableCustomer}
					/>
					{props.errors.client_id && <InlineError text={props.errors.client_id} />}
				</FormGroup>
			</Col>

			{/* project status */}
			<Col md={6}>
				<FormGroup validationState={props.errors.status && "error"}>
					<ControlLabel>Status</ControlLabel>
					<Select
						onChange={(option) => { props.onSelectChange(option, "status"); }}
						name="status"
						placeholder="Choose project status"
						value={props.formData.status || ""}
						options={props.projectStatuses}
						clearable={false}
						multi={false}   										
					/>
				</FormGroup>
			</Col>
		</Row>
		<Row>
			<Col md={6}>
				<FormGroup validationState={props.errors.deadline && "error"}>
					<ControlLabel>Deadline</ControlLabel>
					<DatePicker
						selected={props.selectedDate && moment(props.selectedDate)}
						onChange={props.onDateChange}
						dateFormat="DD-MM-YYYY"
						className="form-control"
						placeholderText="Choose deadline"
						minDate={moment()}
					/>
					{props.errors.deadline && <InlineError text={props.errors.deadline} />}
				</FormGroup>
			</Col>
			<Col md={6}>
				<FormGroup validationState={props.errors.repetitive_type && "error"}>
					<ControlLabel>Type</ControlLabel>
					<Select
						onChange={(option) => { props.onSelectChange(option, "repetitive_type"); }}
						name="repetitive_type"
						placeholder="Choose repeat type"
						value={props.formData.repetitive_type || ""}
						options={[{value: "monthly", label:"Monthly"},{value: "yearly", label:"Yearly"}]}
						clearable={false}
						multi={false}											
					/>
					{props.errors.repetitive_type && <InlineError text={props.errors.repetitive_type} />}
				</FormGroup>
			</Col>
		</Row>
		<Row>
			<Col md={6}>
				<FormGroup validationState={props.errors.budget && "error"}>
					<ControlLabel>Budget</ControlLabel>
					<FormControl type="number" name="budget" placeholder="Enter project budget" value={props.formData.budget || ""} onChange={props.onBudgetChange} />
					{props.errors.budget && <InlineError text={props.errors.budget} />}
				</FormGroup>
			</Col>
		</Row>
	</React.Fragment>
);

RecurringFields.defaultProps = {
	disabled: false,
	disableCustomer: false,
	errors: PropTypes.object,
	selectedDate: null,
	selectedProject: PropTypes.object,
	selectedManager: PropTypes.object,
	selectedCustomer: PropTypes.object
};

RecurringFields.propTypes = {
	disableCustomer: PropTypes.bool,
	disabled: PropTypes.bool,
	selectedDate: PropTypes.string,
	formData: PropTypes.shape({
		repetitive_type: PropTypes.string,
		status: PropTypes.string,
		budget: PropTypes.number
	}).isRequired,
	errors: PropTypes.shape({
		deadline: PropTypes.string,
		repetitive_type: PropTypes.string,
		manager_id: PropTypes.string,
		parent_id: PropTypes.string,
		client_id: PropTypes.string,
		status: PropTypes.string,
		budget: PropTypes.number
	}),
	selectedProject: PropTypes.shape({
		value: PropTypes.number,
		label: PropTypes.string
	}),
	selectedManager: PropTypes.shape({
		value: PropTypes.string,
		label: PropTypes.string
	}),
	selectedCustomer: PropTypes.shape({
		value: PropTypes.string,
		label: PropTypes.string
	}),
	projectStatuses: PropTypes.arrayOf(
		PropTypes.object
	).isRequired,
	onBudgetChange: PropTypes.func.isRequired,
	onDateChange: PropTypes.func.isRequired,
	onSelectChange: PropTypes.func.isRequired,
	onAsyncChange: PropTypes.func.isRequired,
	onCustomerAsyncChange: PropTypes.func.isRequired,
	onParentSelectChange: PropTypes.func.isRequired,
	handleAsyncSearch: PropTypes.func.isRequired,
};

export default RecurringFields;


// WEBPACK FOOTER //
// ./src/components/forms/projects/fields/RecurringFields.js